import React from 'react';
import { SearchIcon, FilterIcon } from 'lucide-react';
export const SearchBar = () => {
  return <div className="mb-6 flex gap-4" data-id="element-1146">
      <div className="flex-1 relative" data-id="element-1147">
        <input type="text" placeholder="Buscar usuarios..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-1148" />
        <SearchIcon className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" data-id="element-1149" />
      </div>
      <div className="relative" data-id="element-1150">
        <button className="px-4 py-2 border border-gray-300 rounded-lg flex items-center gap-2 hover:bg-gray-50" data-id="element-1151">
          <FilterIcon className="h-5 w-5 text-gray-500" data-id="element-1152" />
          <span className="text-gray-700" data-id="element-1153">Filtros</span>
        </button>
      </div>
    </div>;
};